import { DescriptionPage_WeeklyMaterialItemType as WeeklyMaterialItemType } from '__generated__/graphql-types';

import type { WeeklyMaterialFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';
import getGroupedAssessments from 'bundles/unified-description-page-common/utils/getGroupedAssessments';

const getTotalQuizzesAndAssignments = (weeks: WeeklyMaterialFragment[]) => {
  const { totalQuizzes, totalAssignments } = weeks.reduce(
    (prev, week) => {
      const groupedAssessments = getGroupedAssessments(week.assessments);
      const quizzes = groupedAssessments?.[WeeklyMaterialItemType.Quiz];
      const assignments = groupedAssessments?.[WeeklyMaterialItemType.Assignment];

      return {
        totalQuizzes: quizzes?.length ? prev.totalQuizzes + quizzes.length : prev.totalQuizzes,
        totalAssignments: assignments?.length ? prev.totalAssignments + assignments.length : prev.totalAssignments,
      };
    },
    { totalQuizzes: 0, totalAssignments: 0 }
  );

  return { totalQuizzes, totalAssignments };
};

export default getTotalQuizzesAndAssignments;
